import React, { useCallback, useEffect, useMemo, useState } from "react";
import { formatNumber, formatSubcontractorName } from "../../common/Misc";
import ProgressPaymentItem from "./components/ProgressPaymentItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronRight,
  faFileExcel,
  faFilePdf,
  // faFileExport,
} from "@fortawesome/free-solid-svg-icons";
import { API, fileUpload } from "../../../config";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Spin from "../../common/Spin";
import { Dropdown } from "react-bootstrap";

const ProgressPayment = ({ contractOptions, globalContractSelect }) => {
  const [exportLoading, setExportLoading] = useState(false);
  const params = useParams();
  const projectId = params?.project_id;
  const data = useMemo(() => {
    return globalContractSelect?.length > 0
      ? globalContractSelect.map((item) =>
          contractOptions.find((optionItem) => optionItem?.value === item)
        )
      : [];
  }, [globalContractSelect, contractOptions]);

  const [expandedItem, setExpandedItem] = useState(
    data?.length === 1 ? data[0]?.id : null
  );
  useEffect(() => {
    setExpandedItem(data?.length === 1 ? data[0]?.id : null);
  }, [data]);

  const toggleExpand = (id) => {
    setExpandedItem(expandedItem === id ? null : id);
  };

  const handleExport = useCallback(
    async (contracts, format) => {
      try {
        setExportLoading(true);
        const formData = new FormData();
        formData.append("format", format);
        for (let i = 0; i < contracts?.length; i++) {
          formData.append(`contracts[${i}]`, contracts[i]);
        }
        formData.append("export", 1);
        formData.append("builder_project_id", projectId);
        const { data } = await fileUpload(
          `${API.CONTRACT_SUMMARY_REPORT}`,
          formData
        );
        const export_report_path = data?.data?.file;
        setExportLoading(false);
        if (export_report_path) {
          var a = document.createElement("a");
          a.href = export_report_path;
          var file = export_report_path.split("/");
          a.setAttribute(
            "download",
            file[file.length - 1] || "bank_transaction.pdf"
          );
          a.setAttribute("target", "_blank");
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();
          a.remove();
          setExportLoading(false);
        }
      } catch (e) {
        setExportLoading(false);
        const errors = e.response?.data?.errors;
        Object.keys(errors).forEach((key) => {
          toast.error(errors[key][0]);
        });
      }
    },
    [projectId]
  );

  const [childrenData, setChildrenData] = useState({}); // State to store data from all children

  // Callback function to update data from a specific child
  const handleChildData = (id, data) => {
    setChildrenData((prev) => ({
      ...prev,
      [id]: data, // Update data for the specific child
    }));
  };

  const getChildDataById = (id) => {
    return childrenData[id] || null; // Return data if found, otherwise null
  };

  useEffect(() => {
    setChildrenData({});
  }, [globalContractSelect]);

  return (
    <div className="cms-page">
      {data?.length > 0 && (
        <div className="table-top-btn">
          <div className="table-btn">
            <Dropdown>
              <Dropdown.Toggle variant="success" id="dropdown-basic">
                Export All
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() => handleExport(globalContractSelect, "pdf")}
                >
                  <FontAwesomeIcon icon={faFilePdf} /> PDF
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => handleExport(globalContractSelect, "xlsx")}
                >
                  <FontAwesomeIcon icon={faFileExcel} /> Excel
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      )}
      <div className="progress-payment-body">
        {exportLoading && <Spin />}

        {data?.length > 0 ? (
          data?.map((contract, index) => (
            <div key={contract?.id} className="progress-payment-item">
              {/* Header Section */}
              <div
                onClick={() => toggleExpand(contract?.id)}
                className="progress-payment-item-header"
              >
                <div>
                  {expandedItem === contract?.id ? (
                    <FontAwesomeIcon icon={faChevronDown} />
                  ) : (
                    <FontAwesomeIcon icon={faChevronRight} />
                  )}
                </div>
                <div className="progress-payment-item-header-text-body">
                  <div className="progress-payment-item-header-text">
                    {contract?.contract_number}{" "}
                    {formatSubcontractorName(contract?.contact)
                      ? `- ${formatSubcontractorName(contract?.contact)}`
                      : ""}{" "}
                    <div>
                      Total Paid:{" "}
                      {getChildDataById(contract?.id)?.closing_balance_pta
                        ? `$${formatNumber(
                            getChildDataById(contract?.id)?.closing_balance_pta
                          )}`
                        : contract?.closing_balance_pta
                        ? `$${formatNumber(contract?.closing_balance_pta)}`
                        : "$0.00"}
                    </div>
                  </div>
                </div>
              </div>

              {/* Expanded Content */}
              {expandedItem === contract?.id && (
                <div
                  style={{
                    backgroundColor: "#fff",
                    padding: "16px",
                    borderTop: "1px solid #ccc",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: "-33px",
                    }}
                  >
                    <h5>{/* <b>Progress Payment Report</b> */}</h5>{" "}
                    <div
                      className="table-top-btn"
                      style={{
                        margin: "0px",
                      }}
                    >
                      <div className="table-btn">
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="success"
                            id="dropdown-basic"
                          >
                            {/* <FontAwesomeIcon
                              icon={faFileExport}
                              style={{
                                cursor: "pointer",
                              }}
                            /> */}
                            Export
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() =>
                                handleExport([contract?.id], "pdf")
                              }
                            >
                              <FontAwesomeIcon icon={faFilePdf} /> PDF
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() =>
                                handleExport([contract?.id], "xlsx")
                              }
                            >
                              <FontAwesomeIcon icon={faFileExcel} /> Excel
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  </div>

                  <ProgressPaymentItem
                    contractId={contract?.id}
                    handleExport={handleExport}
                    onDataPass={handleChildData}
                  />
                </div>
              )}
            </div>
          ))
        ) : (
          <div>Please Select Contract.</div>
        )}
      </div>
    </div>
  );
};

export default ProgressPayment;
